import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { AboutTraining as Desk } from './desk'
import { AboutTraining as Mob } from './mob'

type Props = {}
export const AboutTraining: React.FC<Props> = () => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return <Component />
}
